<template lang="pug">
#client.container-fluid
  #client-main.row.fullScreen.valign-wrapper
    .col.s12.center(style="")
      img(src="../assets/desktop/landing/2024/Desktop_HomePage_Logo.png" @click="$router.push('/')")
      p(style="font-size:10%")  &nbsp
      div(style="font-size:110%")
        p.Fjalla.largerSize We have
        p(style="font-size:10%")  &nbsp
        p.Fjalla.largerSize social media ears
          span.Oswald(style="line-height:0") .
        p(style="font-size:10%")  &nbsp
      p.Oswald.largeSize and this is what the world is saying about
      p(style="font-size:50%")  &nbsp
      p.Fjalla.largeSize
        span.WhiteAndBlackBox &nbsp&nbsp{{$route.params.project.toUpperCase()}}&nbsp&nbsp
  #counter.row
    br
    .col.s12
      .row.center
        p.Montserrat(style="font-size:70%") LOVE AND HATE IN REAL TIME
        .row.valign-wrapper#counterMain
          .col.s5
            p.Montserrat.smallestSize.rightT#love LOVE {{loveCount}}
          .col.s2
            img.loveMeter(src="../assets/love.png" v-bind:style="meterStyle")
          .col.s5
            p.Montserrat.smallestSize.leftT#hate HATE {{hateCount}}
        .row.smallSize.Montserrat#tweets
          .col.s1
          .col.s4.tweet(v-if="love.text")
            p.rightT
              b(style="color:white") {{love.user.name	}}
              |  @{{love.user.screen_name	}}
            p.rightT {{love.text}}
          .col.s2
            p <br><br><br><br><br>
          .col.s4.tweet(v-if="hate.text")
            p.leftT
              b(style="color:white") {{hate.user.name	}}
              |  @{{hate.user.screen_name	}}
            p.leftT {{hate.text}}
  #LoveAndHate
    #LoveSection.row.fullScreen.valign-wrapper
      img(src="../assets/FoundersBio_Heart_Icon379.png")
      .col.s6(style="font-size:250%")
        p.Fjalla.rightT LOVING&nbsp&nbsp
      .col.s6
        .row.valign-wrapper(style="margin-bottom: 0")
          .col.s2
            i.material-icons(@click="postsI.love = postsI.love != 0 ? postsI.love - 1 : posts.love.length - 1" style="font-size:150%") chevron_left
          .col.s8(v-if="posts.love.length")
            tweet(v-if="!posts.love[postsI.love].image" :t="posts.love[postsI.love]" width="100%" height="100%" noControls :key="postsI.love")
            instagram(v-if="posts.love[postsI.love].image" :i="posts.love[postsI.love]" style="margin-left: 5%;" width="90%" height="700px" noControls :key="postsI.love")
          .col.s2
            i.material-icons(@click="postsI.love = postsI.love != posts.love.length - 1 ? postsI.love+1 : 0" style="font-size:150%") chevron_right
    #HateSection.row.fullScreen.valign-wrapper
      img(src="../assets/BigH_Founders.png")
      .col.s6(style="font-size:250%")
        p.Fjalla.rightT HATING&nbsp&nbsp
      .col.s6
        .row.valign-wrapper(style="margin-bottom: 0")
          .col.s2
            i.material-icons(@click="postsI.hate = postsI.hate != 0 ? postsI.hate - 1 : posts.hate.length - 1" style="font-size:150%") chevron_left
          .col.s8(v-if="posts.hate.length")
            tweet(v-if="!posts.hate[postsI.hate].image" :t="posts.hate[postsI.hate]" width="100%" height="100%" noControls :key="postsI.hate" style="max-height:90vh; overflow-y:hidden")
            instagram(v-if="posts.hate[postsI.hate].image" :i="posts.hate[postsI.hate]" style="margin-left: 5%;" width="90%" height="800px" noControls :key="postsI.hate")
          .col.s2
            i.material-icons(@click="postsI.hate = postsI.hate != posts.hate.length - 1 ? postsI.hate+1 : 0" style="font-size:150%") chevron_right
</template>

<script>
//var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "";
var baseUrl = "https://loversnothaters.com";
import tweet from '@/components/tweet';
import instagram from '@/components/instagram';

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default {
  components:{
    tweet,
    instagram
  },
  data(){
    return {
      project: {},
      tweets: {positive:[], neutral:[], negative:[], users: [], count: {}},
      instagram: {positive:[], neutral:[], negative:[], users: [], count: {}},
      total: {positive:0, neutral:0, negative:0, users: 0},
      posts: {love:[], hate:[]},
      postsI: {love:0, hate:0},
      love: {},
      hate: {},
      loveCount: 0,
      hateCount: 0,
      lovePercent: 0,
      meterStyle:{
        background: ""
      }
    }
  },
  mounted(){
    this.getPositiveTweets(1);
    this.getNegativeTweets(1);
    this.getPositiveInstagram(1);
    this.getNegativeInstagram(1);
    this.getLovePosts();
    this.getHatePosts();
    setInterval(()=>{
      var loveRand = Math.floor(Math.random() * this.tweets.positive.length)
      this.love = this.tweets.positive[loveRand];
      var hateRand = Math.floor(Math.random() * this.tweets.positive.length)
      this.hate = this.tweets.negative[hateRand];
    }, 5000);
  },
  beforeUpdate(){
    var per = this.loveCount / (this.loveCount + this.hateCount) * 100;
    this.meterStyle.background = "-webkit-linear-gradient(-90deg, #00ffff 0%, #00ffff " + Math.floor(per) + "%, #AAA " + Math.floor(per) + "%, #AAA 100%)";
  },
  methods:{
    getPositiveTweets(limit, beforeId){
      console.log("Positive Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/posTweets/" + this.$route.params.project + "?limit=6" + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.tweets.count.positive = data.count;
        this.loveCount = data.count + this.instagram.count.positive;
        data.tweets.forEach((t)=>{
          this.tweets.positive.push(t);
        });
        if(this.tweets.positive[0]) this.love = this.tweets.positive[0];
        this.total.positive = data.count;
      });
    },
    getNegativeTweets(limit, beforeId){
      console.log("Negative Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/negTweets/" + this.$route.params.project + "?limit=6" + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.tweets.count.negative = data.count;
        this.hateCount = data.count + this.instagram.count.negative;
        data.tweets.forEach((t)=>{
          this.tweets.negative.push(t);
        });
        if(this.tweets.negative[0]) this.hate = this.tweets.negative[0];
        this.total.negative = data.count;
      });
    },
    getPositiveInstagram(limit, beforeId){
      console.log("Positive Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/posInstagram/" + this.$route.params.project + "?limit=" + (limit || 6) + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.instagram.count.positive = data.count;
        this.loveCount = data.count + this.tweets.count.positive;
        data.posts.forEach((p)=>{
          this.instagram.positive.push(p);
        });
      });
    },
    getNegativeInstagram(limit, beforeId){
      console.log("Negative Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/negInstagram/" + this.$route.params.project + "?limit=" + (limit || 6) + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.instagram.count.negative = data.count;
        this.hateCount = data.count + this.tweets.count.negative;
        this.hateCount += data.count;
        data.posts.forEach((p)=>{
          this.instagram.negative.push(p);
        });
      });
    },
    getLovePosts(){
      var proms = [];
      proms.push(axios.get(baseUrl + "/projects/likedTweets/" + this.$route.params.project + "/love?limit=100").then(({data}) => data));
      proms.push(axios.get(baseUrl + "/projects/likedInstagrams/" + this.$route.params.project + "/love?limit=100").then(({data}) => data));
      Promise.all(proms).then((data)=>{
        Array.prototype.push.apply(data[0],data[1])
        //console.log(data[0])
        this.posts.love = shuffle(data[0]);
      });
    },
    getHatePosts(){
      var proms = [];
      proms.push(axios.get(baseUrl + "/projects/likedTweets/" + this.$route.params.project + "/hate?limit=100").then(({data}) => data));
      proms.push(axios.get(baseUrl + "/projects/likedInstagrams/" + this.$route.params.project + "/hate?limit=100").then(({data}) => data));
      Promise.all(proms).then((data)=>{
        Array.prototype.push.apply(data[0],data[1])
        //console.log(data[0])
        this.posts.hate = shuffle(data[0]);
      });
    },
  }
}
</script>

<style lang="sass" scoped>
#client
  #client-main
    background-color: black
    background-image: url("../assets/Counter_ClientInterface_BGimage.jpg")
    background-size: cover
    -webkit-background-size: cover
    -moz-background-size: cover
    -o-background-size: cover
    background-position: center center
    background-repeat: no-repeat
    color: white
    img
      width: 25vw
      image-rendering: auto
  #counter
    background-color: black
    color: white
    padding-bottom: 0
    margin-bottom: 0
    font-size: 2.2vw
    width: 100vw
    background-color: black
    margin: 0px
    color: white
    p
      margin: 0
      line-height: 1.4
    .loveMeter
      width: 50%
    #counterMain
      padding-top: 10px
      font-weight: 200
    #love
      font-size: 110%
      font-weight: 300
      color: #00ffff
    #hate
      font-size: 110%
      font-weight: 300
      color: rgb(153,153,153)
    #tweets
      font-size: 60%
      font-weight: 400
      color: #CCCCCC
    .tweet
      position: relative
      top: -30px
  .leftT
    position: relative
    text-align: left
    left: -2.5vw
  .rightT
    position: relative
    text-align: right
    right: -2.5vw
  #LoveAndHate
    margin-bottom: 0
    padding: 0
    #LoveSection
      position: relative
      //min-height: 50vh
      margin-bottom: 0
      img
        position: absolute
        max-height: 70%
        max-width: 35%
        bottom: 0
        transform: rotate(90deg)
    #HateSection
      position: relative
      //min-height: 50vh
      background-color: rgb(10,10,10)
      color: white
      margin-bottom: 0
      img
        position: absolute
        max-height: 90%
        max-width: 20%
</style>



// WEBPACK FOOTER //
// src/components/client.vue